module.exports = __webpack_public_path__ + "img/c_3.5a75d3e4.png";